import styled from 'styled-components';

import { Box } from '@/components/Box';
import { Flex } from '@/components/Flex';
import { Row } from '@/components/Row';
import { Typography } from '@/components/Typography';
import { theme } from '@/theme';

export const Title = styled(Typography)`
  margin-top: ${theme.spacing(4)};
  text-align: center;
  text-transform: uppercase;
  font-family: ${theme.fontFamilies.italianPlate};
  font-size: 1.5rem;
  font-weight: ${theme.fontWeights.semibold};
`;

export const RetailerSelectWrapper = styled(Box)`
  > * {
    margin-top: ${theme.spacing(2)};
  }
`;

export const FormWrapper = styled(Row)`
  > * {
    margin-top: ${theme.spacing(2)};
  }
  input:disabled {
    color: hsl(0, 0%, 50%);
  }
  a {
    color: ${theme.colors.primaryDark};
  }
`;
export const PhoneInputWrapper = styled(Flex)`
  grid-gap: ${theme.spacing(2)};
  > * {
    flex: 1;
  }
`;

export const ResultWrapper = styled(Box)`
  padding-top: ${theme.spacing(2)};
  text-align: center;
`;
export const ProductInfo = styled(Flex)`
  margin-top: ${theme.spacing(4)};
  background: ${theme.colors.secondaryLightGrey};
  justify-content: center;
  align-items: center;
`;
export const ProductCardDetails = styled(Flex)`
  flex-flow: column;
  width: auto;
`;
export const ProductName = styled(Typography)`
  font-family: ${theme.fontFamilies.italianPlate};
  font-weight: ${theme.fontWeights.semibold};
`;
export const ProductImageWrapper = styled(Box)`
  position: relative;
  height: 160px;
  width: 160px;
`;
